import React from 'react';
import { styled } from '@linaria/react';
import vioGif from './vio.gif';
type Size = 'sm' | 'md' | 'lg';
interface Props {
  size?: Size;
}
const sizesMap = {
  sm: 22,
  md: 44,
  lg: 88
};
const _exp = /*#__PURE__*/() => ({
  size
}) => `${{
  sm: 22,
  md: 44,
  lg: 88
}[size]}px`;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wicr2l5",
  propsAsIs: false,
  vars: {
    "wicr2l5-0": [_exp()]
  }
});
export const AnimatedLogo = ({
  size = 'md'
}: Props) => {
  return <Wrapper size={size}>
      <img src={vioGif} width={sizesMap[size]} alt="vio-logo-gif" />
    </Wrapper>;
};

require("./AnimatedLogo.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AnimatedLogo.tsx");